// @flow
import { get } from 'lodash';

type Image = {
  res1x: string,
  res2x: string
};

function decodeGiftImage(image: Object = {}): Image {
  return {
    res1x: get(image, '1x'),
    res2x: get(image, '2x')
  };
}

export default decodeGiftImage;
